import { WhatsAppSenderFields } from 'modules/graphql';
import { useTakeoverContext } from 'modules/sendingPlatforms/contexts';
import styled from 'styled-components';
import { OverflowMenu } from 'ui/actionMenu';
import { StyledOption } from 'ui/actionMenu/ActionMenu.styles';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { BUTTON_SIZES } from 'ui/button';
import { OpenNewWindow24, View24 } from 'ui/icons';
import { colors, spacing } from 'ui/theme';
import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';

const META_BUSINESS_URL = 'https://business.facebook.com/';

// Having the icon at the end of the option has some weird rendering with the component grid styling
// since it expects any svg icon rendered to be at the beginning of the option so just overriding display
const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${spacing.half};

  ${StyledOption} {
    display: flex;

    &:hover {
      color: ${colors.textLink};
      background-color: ${colors.backgroundInteractive};
    }
  }
`;

type Props = { sender: WhatsAppSenderFields };

export const BusinessProfilesOverflowMenu = ({ sender }: Props) => {
  const { isWhatsAppGAEnabled } = useWhatsAppMessageChannelFeature();
  const { openTakeover } = useTakeoverContext();

  const options = [
    ...(isWhatsAppGAEnabled
      ? [
          {
            id: 'view-business-details',
            label: 'View',
            content: (
              <>
                <View24 />
                View business details
              </>
            ),
            onClick: () => {
              openTakeover(sender);
            },
            as: AllowedActionMenuElements.Button,
          },
        ]
      : [
          {
            id: 'view-business-details-on-meta',
            content: (
              <ContentWrapper>
                View details in Meta
                <OpenNewWindow24 isColorInherited />
              </ContentWrapper>
            ),
            href: META_BUSINESS_URL,
            target: '_blank',
            isExternalLink: true,
            as: AllowedActionMenuElements.Link,
            Wrapper: ContentWrapper,
          },
        ]),
  ];

  return (
    <OverflowMenu
      id="business-profiles-overflow-menu"
      options={options}
      size={BUTTON_SIZES.LARGE}
    />
  );
};
